import { Injectable, Inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AuthenticationService } from '../../core/services/auth.service';
import { TokenStorageService } from '../../core/services/token-storage.service';
import { login, loginSuccess, loginFailure, logout, logoutSuccess } from './authentication.actions';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthenticationEffects {

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(login),
      exhaustMap(({ email, password }) => {
        if (environment.defaultauth === 'strapi') {
          return this.authService.login(email, password).pipe(
            map((response) => {
              // Save session using TokenStorageService
              this.tokenStorage.saveSession(
                response.jwt,
                response.user,
                response.user.empresaActiva
              );

              // Set flag for welcome toast
              localStorage.setItem('toast', 'true');

              // Navigate to dashboard
              this.router.navigate(['/']);

              return loginSuccess({ user: response.user as any });
            }),
            catchError((error) => {
              // AuthService returns error as string, but handle other cases too
              let errorMessage = 'Error al iniciar sesión';
              if (typeof error === 'string') {
                errorMessage = error;
              } else if (error?.message && typeof error.message === 'string') {
                errorMessage = error.message;
              }
              return of(loginFailure({ error: errorMessage }));
            })
          );
        } else if (environment.defaultauth === 'fakebackend') {
          return this.authService.login(email, password).pipe(
            map((response: any) => {
              if (response.jwt) {
                this.tokenStorage.saveSession(response.jwt, response.user);
                localStorage.setItem('toast', 'true');
                this.router.navigate(['/']);
              }
              return loginSuccess({ user: response.user });
            }),
            catchError((error) => of(loginFailure({ error })))
          );
        } else {
          return of(loginFailure({ error: 'Método de autenticación no configurado' }));
        }
      })
    )
  );

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(logout),
      tap(() => {
        this.tokenStorage.signOut();
        this.router.navigate(['/auth/signin/cover']);
      }),
      exhaustMap(() => of(logoutSuccess()))
    )
  );

  constructor(
    @Inject(Actions) private actions$: Actions,
    private authService: AuthenticationService,
    private tokenStorage: TokenStorageService,
    private router: Router
  ) {}
}
